import { UnitConditionType, UnitIcons } from '@shared/enums/unit-condition.enum';
import { IRadioButtonOption } from '@shared/interfaces/radio-button-option.interface';

export const UnitConditionListConst: IRadioButtonOption<UnitConditionType>[] = [
  {
    value: UnitConditionType.Bad,
    label: 'bad',
  },
  {
    value: UnitConditionType.Fair,
    label: 'fair',
  },
  {
    value: UnitConditionType.Good,
    label: 'good',
  },
  {
    value: UnitConditionType.Excellent,
    label: 'excellent',
  },
];

export const UnitIconList: IRadioButtonOption<UnitIcons>[] = [
  {
    value: UnitIcons.clubhouse,
    label: 'Clubhouse',
    icon: UnitIcons.clubhouse,
  },
  {
    value: UnitIcons.commonArea,
    label: 'Common Area',
    icon: UnitIcons.commonArea,
  },
  {
    value: UnitIcons.exteriorCommonArea,
    label: 'Exterior Common Area',
    icon: UnitIcons.exteriorCommonArea,
  },
  {
    value: UnitIcons.fitnessCenter,
    label: 'Fitness Center',
    icon: UnitIcons.fitnessCenter,
  },
  {
    value: UnitIcons.landscapeArea,
    label: 'Landscape area',
    icon: UnitIcons.landscapeArea,
  },
  {
    value: UnitIcons.leasingCenter,
    label: 'Leasing Center',
    icon: UnitIcons.leasingCenter,
  },
  {
    value: UnitIcons.lobby,
    label: 'Lobby',
    icon: UnitIcons.lobby,
  },
  {
    value: UnitIcons.other,
    label: 'Other',
    icon: UnitIcons.other,
  },
  {
    value: UnitIcons.pool,
    label: 'Pool',
    icon: UnitIcons.pool,
  },
  {
    value: UnitIcons.petPark,
    label: 'Pet Park',
    icon: UnitIcons.petPark,
  },
  {
    value: UnitIcons.propertyIcon,
    label: 'Property',
    icon: UnitIcons.propertyIcon,
  },
  {
    value: UnitIcons.unit,
    label: 'Unit',
    icon: UnitIcons.unit,
  },
];

export enum PMSExcludedFromOccupancyType {
  All = 1,
  Yes,
  No,
}

export const ExcludedFromOccupancyList: IRadioButtonOption<number>[] = [
  {
    value: PMSExcludedFromOccupancyType.All,
    label: 'All',
  },
  {
    value: PMSExcludedFromOccupancyType.Yes,
    label: 'Yes',
  },
  {
    value: PMSExcludedFromOccupancyType.No,
    label: 'No',
  },
];
